import { sitePhrasing } from "../../../../Language/languageHandler";
import { AddressInputFieldGroup } from "../../../FormFields/AddressFieldGroup/AddressInputFieldGroup";
import { ArrayFieldInput } from "../../../FormFields/ArrayField/ArrayFieldInput";
import CheckboxInputField from "../../../FormFields/CheckboxInputField/CheckboxInputField";
import RadioInputField from "../../../FormFields/RadioInputField/RadioInputField";
import TextInputField from "../../../FormFields/TextInputField/TextInputField";
import { ContactInfoFields } from "../ContactInfoFields";
import { annualReportDisclaimer1, blankRegisteredAgentFn, electronicSignatureSublabel, iAgreeText, laborLawPosterAgreementText, mayBeContactedAgreementText, registeredAgentFields, stateTransactionAcknowledgmentText, yesOrNoValues } from "../PurchaseConstants";
import { forcedRegistered } from "../PurchaseFormHelpers";
import { AnnualReferenceNumberInstructions, TermsAndConditionAcceptText } from "../SharedPurchaseFieldComponents";
import { NorthCarolinaAnnualReportTerms } from "./StateSpecificAnnualTerms";

export default function NorthCarolinaAnnualReportFields(props: {
  errors: any;
  touched: any;
  values: any;
  setFieldValue: (field: string, value: any) => void;
  selectedProducts: any;
}) {
  const {
    errors,
    touched,
    values,
    setFieldValue,
    selectedProducts
  } = props;

  return (
    <>

      <ContactInfoFields
        values={values}
        touched={touched}
        errors={errors}
        setFieldValue={setFieldValue}
      />

      <TextInputField
        mask={sitePhrasing.referenceMask}
        fieldName={"referenceNumber"}
        fieldLabel={"Reference Number"}
        fieldSubLabel={undefined}
        customFieldInstructions={() => (<AnnualReferenceNumberInstructions />)}
        errors={errors}
        touched={touched}
        required={true}
        placeholder={"Reference Number"}
        maskGuide={sitePhrasing.referenceMaskGuide}
      />

      <TextInputField
        fieldName={"businessName"}
        fieldLabel={"Complete Business Name"}
        errors={errors}
        touched={touched}
        required={true}
        placeholder={"Complete Business Name"}
      />


      <RadioInputField
        fieldName={"annualReport.veteranOwned"}
        fieldLabel={"Is 50% or more of your company owned by a U.S. military veteran?"}
        errors={errors}
        required={true}
        touched={touched}
        options={yesOrNoValues}
      />
      {values.annualReport.veteranOwned === "yes" && (
        <RadioInputField
          fieldName={"annualReport.disabledVeteranOwned"}
          fieldLabel={"Is 50% or more of your company owned by a disabled U.S. military veteran?"}
          errors={errors}
          required={true}
          touched={touched}
          options={yesOrNoValues}
        />
      )}
      <RadioInputField
        fieldName={"annualReport.netReceiptsUnder1M"}
        fieldLabel={"Are the net receipts of this company less than $1,000,000?"}
        errors={errors}
        required={true}
        touched={touched}
        options={yesOrNoValues}
      />
      <TextInputField
        fieldName={"annualReport.natureOfBusiness"}
        fieldLabel={"Briefly describe the nature of the business"}
        errors={errors}
        touched={touched}
        required={true}
        placeholder={"Briefly describe the nature of the business"}
      />

      <h3>Do you need to change any of the following information?</h3>
      <RadioInputField
        fieldName={"annualReport.informationChange.principalAddress.changed"}
        fieldLabel={"Principal Address?"}
        errors={errors}
        required={true}
        touched={touched}
        options={yesOrNoValues}
        fieldSubLabel="No PO Boxes"
        customClass={'error-sub-label bold-sub-label'}
      />
      {values.annualReport.informationChange.principalAddress.changed === "yes" && (
        <AddressInputFieldGroup
          fieldName={"annualReport.informationChange.principalAddress.newAddress"}
          errors={errors}
          touched={touched}
        />
      )}

      <RadioInputField
        fieldName={"annualReport.informationChange.mailingAddress.changed"}
        fieldLabel={"Mailing Address?"}
        errors={errors}
        required={true}
        touched={touched}
        options={yesOrNoValues}
      />
      {values.annualReport.informationChange.mailingAddress.changed === "yes" && (
        <AddressInputFieldGroup
          fieldName={"annualReport.informationChange.mailingAddress.newAddress"}
          errors={errors}
          touched={touched}
        />
      )}

      <RadioInputField
        fieldName={"annualReport.informationChange.registeredAgent.agentChange"}
        fieldLabel={"Registered Agent?"}
        errors={errors}
        required={true}
        touched={touched}
        options={yesOrNoValues}
      />
      {values.annualReport.informationChange.registeredAgent.agentChange === "yes" && (
        <>
          <TextInputField
            fieldName={"annualReport.informationChange.registeredAgent.newAgent"}
            fieldLabel={"Registered Agent Name"}
            errors={errors}
            touched={touched}
            required={true}
            placeholder={"Registered Agent Name"}
          />

          <TextInputField
            fieldName={"annualReport.informationChange.registeredAgent.email"}
            fieldLabel={"Registered Agent Email"}
            errors={errors}
            touched={touched}
            required={true}
            placeholder={"Registered Agent Email"}
          />
        </>
      )}

      <RadioInputField
        fieldName={"annualReport.informationChange.registeredAgent.agentAddressChange"}
        fieldLabel={"Registered Agent Address?"}
        errors={errors}
        required={true}
        touched={touched}
        options={yesOrNoValues}
        onChange={(e: any) => {
          setFieldValue("annualReport.informationChange.registeredAgent.agentAddressChange", e.target.value);
          setFieldValue("annualReport.informationChange.registeredAgent.agentMailingAddressChange", "");
          setFieldValue("annualReport.informationChange.registeredAgent.agentStreetAddressChange", "");
        }}
      />

      {values.annualReport.informationChange.registeredAgent.agentAddressChange === "yes" && (
        <>
          <RadioInputField
            fieldName={"annualReport.informationChange.registeredAgent.agentMailingAddressChange"}
            fieldLabel={"Registered Agent Mailing Address?"}
            errors={errors}
            required={true}
            touched={touched}
            options={yesOrNoValues}
          />
          {values.annualReport.informationChange.registeredAgent.agentMailingAddressChange === "yes" && (
            <AddressInputFieldGroup
              fieldName={"annualReport.informationChange.registeredAgent.newAddress"}
              errors={errors}
              touched={touched}
              fieldMessages={{
                state: forcedRegistered[sitePhrasing.state] ? `Your registered agent must be located in ${sitePhrasing.state}.` : ``,
              }}
              disableFields={{
                state: forcedRegistered[sitePhrasing.state] ? true : false,
              }}
            />
          )}

          <RadioInputField
            fieldName={"annualReport.informationChange.registeredAgent.agentStreetAddressChange"}
            fieldLabel={"Registered Agent Street Address?"}
            errors={errors}
            required={true}
            touched={touched}
            options={yesOrNoValues}
            fieldSubLabel="No PO Boxes"
            customClass={'error-sub-label bold-sub-label'}
          />
          {values.annualReport.informationChange.registeredAgent.agentStreetAddressChange === "yes" && (
            <>
              <AddressInputFieldGroup
                fieldName={"annualReport.informationChange.registeredAgent.newStreetAddress"}
                errors={errors}
                touched={touched}
                fieldMessages={{
                  state: forcedRegistered[sitePhrasing.state] ? `Your registered agent must be located in ${sitePhrasing.state}.` : ``,
                }}
                disableFields={{
                  state: forcedRegistered[sitePhrasing.state] ? true : false,
                }}
              />
              <TextInputField
                fieldName={"annualReport.informationChange.registeredAgent.newStreetAddress.county"}
                fieldLabel={"County"}
                errors={errors}
                touched={touched}
                required={true}
                placeholder={"County"}
              />
            </>
          )}
        </>
      )}

      <RadioInputField
        fieldName={"annualReport.informationChange.authorizedPerson.authorizedPersonChange"}
        fieldLabel={"Company Officials or Company Officials' Address?"}
        errors={errors}
        required={true}
        touched={touched}
        options={yesOrNoValues}
      />
      {values.annualReport.informationChange.authorizedPerson.authorizedPersonChange === "yes" && (
        <>
          <RadioInputField
            fieldName={"annualReport.informationChange.authorizedPerson.removingAgents"}
            fieldLabel={`Are you removing any Company Officials?`}
            errors={errors}
            required={true}
            touched={touched}
            options={yesOrNoValues}
          />
          {values.annualReport.informationChange.authorizedPerson.removingAgents === "yes" && (
            <ArrayFieldInput
              fieldName={"annualReport.informationChange.authorizedPerson.removedAgents"}
              values={values.annualReport.informationChange.authorizedPerson.removedAgents}
              blankEntryFn={blankRegisteredAgentFn}
              fields={registeredAgentFields}
              touched={touched}
              errors={errors}
              removeText={"- Click to remove entry"}
              addText={"+ Click to add an entry"}
            />
          )}

          <RadioInputField
            fieldName={"annualReport.informationChange.authorizedPerson.addingAgents"}
            fieldLabel={`Are you adding any Company Officials?`}
            errors={errors}
            required={true}
            touched={touched}
            options={yesOrNoValues}
          />
          {values.annualReport.informationChange.authorizedPerson.addingAgents === "yes" && (
            <ArrayFieldInput
              fieldName={"annualReport.informationChange.authorizedPerson.addedAgents"}
              values={values.annualReport.informationChange.authorizedPerson.addedAgents}
              blankEntryFn={blankRegisteredAgentFn}
              fields={registeredAgentFields}
              touched={touched}
              errors={errors}
              removeText={"- Click to remove entry"}
              addText={"+ Click to add an entry"}
            />
          )}

          <RadioInputField
            fieldName={"annualReport.informationChange.authorizedPerson.changingAddresses"}
            fieldLabel={`Are you changing a Company Officials address?`}
            errors={errors}
            required={true}
            touched={touched}
            options={yesOrNoValues}
          />
          {values.annualReport.informationChange.authorizedPerson.changingAddresses === "yes" && (
            <ArrayFieldInput
              fieldName={"annualReport.informationChange.authorizedPerson.changedAddresses"}
              values={values.annualReport.informationChange.authorizedPerson.changedAddresses}
              blankEntryFn={blankRegisteredAgentFn}
              fields={registeredAgentFields}
              touched={touched}
              errors={errors}
              removeText={"- Click to remove entry"}
              addText={"+ Click to add an entry"}
            />
          )}
        </>
      )}

      <div className="terms-and-conditions-container">
        <NorthCarolinaAnnualReportTerms />
        <br /><br />
        {iAgreeText}
        <br /><br />
        {selectedProducts["laborLawPoster"] && (
          <>
            {laborLawPosterAgreementText}
            <br /><br />
          </>
        )}
        {stateTransactionAcknowledgmentText}
        <br /><br />
        <TermsAndConditionAcceptText />
      </div>

      <CheckboxInputField
        fieldName={'termAndConditionAgree'}
        fieldLabel={`I've read and accept the terms and conditions.`}
        touched={touched}
        errors={errors}
        onChange={(e: any) => {
          const checkedVal = e.target.checked ? true : false;
          setFieldValue('annualReport.annualAgree', checkedVal)
          setFieldValue('annualReport.iAmAuthorized', checkedVal)
          setFieldValue('iAgree', checkedVal)
          setTimeout(() => {
            setFieldValue('termAndConditionAgree', checkedVal)
          }, 0)

        }}
      />

      <TextInputField
        fieldName={"annualReport.electronicSignature"}
        fieldLabel={"Name of Individual Signing - Electronic Signature"}
        fieldSubLabel={electronicSignatureSublabel}
        fieldSubLabelCustomClass={'red-text'}
        errors={errors}
        touched={touched}
        required={true}
        placeholder={"Electronic Signature"}
        customClass={"signature-font"}
      />

      <TextInputField
        fieldName={"annualReport.title"}
        fieldLabel={"Title"}
        errors={errors}
        touched={touched}
        required={true}
        placeholder={"Title"}
      />

      <AddressInputFieldGroup
        fieldName={"annualReport.signerAddress"}
        errors={errors}
        touched={touched}
      />

    </>)
}